/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_CreateInputs */

const vi_pl_pxk_create = /** @type {(inputs: Pl_Pxk_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo PXK`)
};

/**

* @param {Pl_Pxk_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_create = /** @type {((inputs?: Pl_Pxk_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_create(inputs)
});